import axios from "axios";

export const FETCH_IMPORT_REVIEWS_FORM_REQUEST =
    "FETCH_IMPORT_REVIEWS_FORM_REQUEST";
export const FETCH_IMPORT_REVIEWS_FORM_SUCCESS =
    "FETCH_IMPORT_REVIEWS_FORM_SUCCESS";
export const FETCH_IMPORT_REVIEWS_FORM_FAILURE =
    "FETCH_IMPORT_REVIEWS_FORM_FAILURE";

export const FETCH_IMPORT_REVIEWS_SUCCESS = "FETCH_IMPORT_REVIEWS_SUCCESS";
export const FETCH_IMPORT_REVIEWS_FAILURE = "FETCH_IMPORT_REVIEWS_FAILURE";
export const UPDATE_IMPORT_REVIEWS_REQUEST = "UPDATE_IMPORT_REVIEWS_REQUEST";
export const RESET_IMPORT_REVIEW_STATE = "RESET_IMPORT_REVIEW_STATE";

export const fetchimportReviewsSuccess = (reviews) => {
    return {
        type: FETCH_IMPORT_REVIEWS_SUCCESS,
        payload: reviews,
    };
};

export const importReviewsFailure = (error) => {
    return {
        type: FETCH_IMPORT_REVIEWS_FAILURE,
        payload: error,
    };
};

export const fetchImportReviewsFormRequest = (data) => {
    return {
        type: FETCH_IMPORT_REVIEWS_FORM_REQUEST,
        payload: data,
    };
};

export const fetchImportReviewsFormSuccess = (data) => {
    return {
        type: FETCH_IMPORT_REVIEWS_FORM_SUCCESS,
        payload: data,
    };
};

export const fetchImportReviewsFormFailure = (error) => {
    return {
        type: FETCH_IMPORT_REVIEWS_FORM_FAILURE,
        payload: error,
    };
};

export const importReviewsRequest = (data) => {
    return {
        type: UPDATE_IMPORT_REVIEWS_REQUEST,
        payload: { data: data },
    };
};
export const importReviewsResetState = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_IMPORT_REVIEW_STATE });
    };
};

export const fetchImportReviewsForm = (type) => {
    return async (dispatch) => {
        dispatch(fetchImportReviewsFormRequest(type));
        try {
            const response = await axios.get(`/reviews/import/${type}`);

            dispatch(fetchImportReviewsFormSuccess(response.data));
        } catch (error) {
            console.log("error........", error);
            dispatch(fetchImportReviewsFormFailure(error.message));
        }
    };
};

const createAutomaticImport = async (data) => {
    if (data?.automaticImport !== true)
        return;

    const body = {
        product_id: data.product,
        type: data.source,
        count: data.maxImportAmazon,
        rating: data.rating,
        url: data.url,
        picture: data.withPicture
    };
    await axios.post("/add-review-schedule", body);
};
export const updateImportReviews = (data) => {
    return async (dispatch) => {
        dispatch(importReviewsRequest(data));
        try {
            console.log("Request data ::", data);

            if (data.import_review) {
                const response = await axios.post(
                    "/reviews/import/aliexpress",
                    { selected_reviews: data.selected_reviews }
                );
                console.log("Responses ::", response);
                dispatch(fetchimportReviewsSuccess(response.data));
                createAutomaticImport(data);
            } else {
                let formData =
                    data.source != "amazon" && data.source != "aliexpress"
                        ? new FormData()
                        : "";
                if (data.source != "amazon" && data.source != "aliexpress") {
                    formData.append("file", data.file);
                    formData.append("source", data.source);
                } else {
                    formData = data;
                }

                const response = await axios.post("/reviews/import", formData);
                console.log("Response ::", response);
                dispatch(fetchimportReviewsSuccess(response.data));
                createAutomaticImport(data);
            }
        } catch (error) {
            console.log(error);
            dispatch(importReviewsFailure(error.message));
        }
    };
};
